import axios from "axios";

export const adminGetVideos = async (query) => {
  const url = axios.getUri({ url: "/api/admin/video", params: query }) || "/api/admin/video";
  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });
};

export const adminCreateVideo = async (payload) => {
  const url = "/api/admin/video";
  return axios.post(url, payload, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });
};

export const adminUpdateVideo = async (id, payload) => {
  const url = `/api/admin/video/${id}`;
  return axios(url, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(payload),
  });
};

export const adminDeleteVideo = async (id) => {
  const url = `/api/admin/video/${id}`;
  return axios(url, {
    method: "DELETE",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });
};

export const getPublicVideos = async () => {
  const url = "/api/videos";
  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });
};


